<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
	<mat-drawer-container class="drawer-container">
		<mat-drawer class="drawer side-bar-class" mode="side" opened>
			<div class="drawer__header">
				<div class="drawer__header--icon">
					<div class="hamburger-menu">
						<mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
							(click)="toggleSidebar()">chevron_left</mat-icon>
					</div>
					<img class="ps4-icon" src="assets/images/sect4-logo.svg" alt="Primaria Sectorului 4" />
					<div class="drawer__header--text">
						<div class="drawer__header--text--title">{{appName}}<br/></div>
						<div class="drawer__header--text--title--minWidth">DGITL</div>
						<div class="drawer__header--text--subtitle faded-text">
							{{appDescription}}
						</div>
						<div class="drawer__header--text--subtitle--minWidth faded-text">
							PO
						</div>
                    </div>

                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="navigateToInDesk()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
				</div>
			</div>
			<div class="drawer__buttons">
				<mat-accordion>

					<p *ngIf="permissionsService.hasPermission('payments-module.plati-online.list')" class="menu-link" routerLink="/plati-online"
						[class.menu-active]="'/plati-online' === activeOption" (click)="setActive('/plati-online')">
						<img src="/assets/icons/plati-online.svg" alt="Plăți Online" />
						<span>Plăți Online</span>
					</p>
					<p *ngIf="permissionsService.hasPermission('payments-module.interogari-plati.list')" class="menu-link" routerLink="/interogari-plati"
						[class.menu-active]="'/interogari-plati' === activeOption"
						(click)="setActive('/interogari-plati')">
						<img src="/assets/icons/interogari-plati.svg" alt="Amenzi Achitate" />
						<span>Interogări și Plăți</span>
					</p>
					<p *ngIf="permissionsService.hasPermission('payments-module.amenzi-achitate.list')" class="menu-link" routerLink="/amenzi-achitate"
						[class.menu-active]="'/amenzi-achitate' === activeOption"
						(click)="setActive('/amenzi-achitate')">
						<img src="/assets/icons/amenzi-achitate.svg" alt="Amenzi Achitate" />
						<span>Amenzi Achitate</span>
					</p>
					<p *ngIf="permissionsService.hasPermission('payments-module.taxe-nedebitate-achitate.list')" class="menu-link" routerLink="/taxe-nedebitate-achitate"
						[class.menu-active]="'/taxe-nedebitate-achitate' === activeOption"
						(click)="setActive('/taxe-nedebitate-achitate')">
						<img src="/assets/icons/taxe-nedebitate-achitate.svg" alt="Taxe Nedebitate Achitate" />
						<span>Taxe Nedebitate Achitate</span>
					</p>
                    <p *ngIf="permissionsService.hasPermission('payments-module.settings.tipuri-amenzi.list') || 
                        permissionsService.hasPermission('payments-module.settings.tipuri-taxe-nedebitate.list')" class="menu-link" routerLink="/settings"
						[class.menu-active]="'/settings' === activeOption" (click)="setActive('/settings')">
						<img src="/assets/icons/settings.svg" alt="Setări" />
						<span>Setări</span>
					</p>

                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('payments-module.administrative')"
                        class="sidenav-accordion" (opened)="panelOpenState2 = true" (closed)="panelOpenState2 = false">
						<mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState2">
							<mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="/assets/icons/administrative.svg" alt="Setări" />
                                    <span>Administrativ</span>
                                </div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<p class="settings-option-menu" routerLink="/admin-settings"
							[class.menu-active]="'/admin-settings' === activeOption"
							(click)="setActive('/admin-settings')">
							<img src="/assets/icons/settings.svg" alt="Setări Administrative" />
							<span>Setări</span>
						</p>
					</mat-expansion-panel>
				</mat-accordion>

				<div class="footer">
					<div class="col-sm-12 px-2" [class.hidden]="isCollapsed == true">
						<small [innerHTML]="env.config.copyrightText"></small>
					</div>
					<div class="logout-button" (click)="logout()">
						<img src="assets/icons/logout.svg" alt="Deconectare" />
						<div click="logout()" class="logout-button--text">Deconectare</div>
					</div>
				</div>
			</div>
		</mat-drawer>
		<mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
			<router-outlet></router-outlet>
		</mat-drawer-content>
	</mat-drawer-container>
</div>